<template>
  <div>
    <headerSection></headerSection>
    <div class="x-main-content x-rewards-page"
         :style="{ 'background-image': `url(${require('../assets/images/Shiba-BG.jpg')})`}">
      <div class="container">

        <!-- Page Header -->
        <div class="x-page-header">
          <div class="x-page-title-component">
            <div class="-inner-wrapper">
              <div class="-icon-wrapper">
                <i class="fas fa-gift"></i>
              </div>
              <h1 class="-title">แลกของรางวัล</h1>
            </div>
          </div>
          <p class="-description">ของรางวัลมีให้แลกมากมาย ที่ DeltaPlus</p>
        </div>

        <!-- User Coins Badge -->
        <div class="x-coins-display">
          <div class="-coins-badge">
            <div class="-coin-icon">
              <i class="fas fa-coins"></i>
            </div>
            <div class="-coin-info">
              <span class="-label">เหรียญของคุณ</span>
              <span class="-value">{{ user && user.coin ? numberWithCommas(user.coin) : '0' }}</span>
            </div>
          </div>
        </div>

        <!-- Rewards Grid -->
        <div class="x-rewards-grid">
          <div
            v-for="(item, index) in rewards"
            :key="index"
            class="x-reward-card"
            :class="{ '-unavailable': !canRedeem(item) }"
            @click="conFirmRedeem(item)"
          >
            <div class="-image-wrapper">
              <img :src="item.image" :alt="item.name" class="-reward-img">
              <div class="-overlay" v-if="!canRedeem(item)">
                <i class="fas fa-lock"></i>
                <span>เหรียญไม่เพียงพอ</span>
              </div>
            </div>
            <div class="-card-content">
              <h3 class="-reward-name">{{ item.name }}</h3>
              <div class="-price-tag">
                <i class="fas fa-coins"></i>
                <span>{{ numberWithCommas(item.point) }}</span>
              </div>
              <button class="-redeem-btn" :disabled="!canRedeem(item)">
                <i class="fas fa-exchange-alt"></i>
                <span>แลกเลย</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Empty State -->
        <div class="x-empty-state" v-if="!rewards || !rewards.length">
          <i class="fas fa-gift"></i>
          <p>ยังไม่มีของรางวัลในขณะนี้</p>
        </div>

        <!-- Info Section -->
        <div class="x-info-card">
          <div class="-info-header">
            <i class="fas fa-info-circle"></i>
            <span>เกี่ยวกับ DeltaPlus</span>
          </div>
          <div class="-info-content">
            <p><a href="https://deltaplus-dp.com" class="-highlight-link">DeltaPlus</a> คาสิโนชั้นนำ รวมแบรนด์ดัง มีทุกค่าย รับง่าย ถอนไว</p>
            <p class="-sub-text">ศูนย์รวมแบรนด์ที่ดีทีสุดและเกมส์คาสิโนทุกเกมส์ไว้ที่นี่ที่เดียว อาทิ UFA IMI AMB EDMBET และ Betflix เฉพาะครอบครัว DeltaPlus เท่านั้น</p>
          </div>
        </div>

      </div>
    </div>
    <footerSection></footerSection>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import moment from 'moment'
const axios = require('axios').default
export default {
  name: 'Home',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  mounted () {
    this.$store.dispatch('user/getRewards').catch(err => { console.error(err) })
  },
  computed: {
    sites_credit () {
      return this.$store.state.user.sites_credit
    },
    user () {
      return this.$store.state.user.user
    },
    rewards () {
      return this.$store.state.user.rewards
    },
    swiper () {
      return this.$refs.mySwiper.$swiper
    },
    lastbonus () {
      return this.$store.state.user.lastbonus
    }
  },
  data () {
    return {
      continueCheck: false,
      receiveAnounceMent: false,
      anoucement: {},
      balance: 0,
      fa_spin: false
    }
  },
  methods: {
    numberWithCommas (x) {
      if (!x) x = 0
      return Number(x).toLocaleString()
    },
    canRedeem (item) {
      return this.user && this.user.key && this.user.coin && Number(this.user.coin) >= Number(item.point)
    },
    checkStyle (item) {
      if ((!this.user || !this.user.key || !this.user.coin || Number(this.user.coin) < item.point)) {
        return 'border-radius:0px;-webkit-filter: grayscale(100%);filter: grayscale(100%);'
      }
    },
    async conFirmRedeem (item) {
      if (!this.canRedeem(item)) return

      this.$store.dispatch('user/refreshCreditAll').finally(async (res) => {
        if (item.turn && Number(item.turn) > 0 && this.user && Number(this.user.credit) > 5) {
          this.$swal({ icon: 'error', title: 'Error!', text: 'ท่านมีมากกว่า 5 เครดิต ไม่สามารถเล่นได้!!!' })
          return false
        }
        if (this.user.coin && Number(this.user.coin) >= Number(item.point)) {
          this.$confirm(
            {
              message: `ต้องการแลกของรางวัล ${item.name}`,
              button: {
                yes: 'ยินยัน',
                no: 'ยกเลิก'
              },
              callback: confirm => {
                if (confirm) {
                  this.$store.commit('user/SET_LOADING', true)
                  setTimeout(() => {
                    firebase.firestore().collection('redeem').add({
                      userkey: this.user.key,
                      code: this.user.code,
                      reward: item.key,
                      type: item.type,
                      credit: (item.credit) ? item.credit : '',
                      point: item.point,
                      status: false,
                      createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                    }).then((result) => {
                      axios({
                        method: 'post',
                        url: 'https://api.deltaplus-dp.com/qmovetowallet/redeem',
                        data: {
                          code: this.user.code,
                          key: result.id
                        }
                      })
                      this.$store.commit('user/SET_LOADING', false)
                    })
                  }, Math.floor(Math.random() * 3000))
                }
              }
            }
          )
        }
      });
    },
    async redeem (item) {
      if (!(!this.user || !this.user.key || !this.user.coin || Number(this.user.coin) < item.point)) {
        if (item.type === 'credit') {
          this.$store.dispatch('user/refreshCreditAll').finally(res => {
            if (this.sites_credit.credit >= 5) {
              this.$swal({ icon: 'error', title: 'แลกเครดิต', html: 'ไม่สามารถแลกเครดิตได้เนื่องจากมียอดคงเหลือมากกว่า 5 บาท' })
            } else {
              this.conFirmRedeem(item)
            }
          })
        } else {
          this.conFirmRedeem(item)
        }
      }
    }
  }
}
</script>
<style scoped>
.x-rewards-page {
  min-height: 100vh;
  padding: 25px 0 120px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

/* Page Header */
.x-page-header {
  text-align: center;
  padding: 20px 0;
}

.x-page-title-component .-inner-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.x-page-title-component .-icon-wrapper {
  width: 50px;
  height: 50px;
  background: linear-gradient(180deg, #ffe867 10%, #fe8a02);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 20px rgba(254, 195, 63, 0.5);
}

.x-page-title-component .-icon-wrapper i {
  font-size: 22px;
  color: #1b1b41;
}

.x-page-title-component .-title {
  font-family: 'Kanit', sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #ffc107;
  margin: 0;
  text-shadow: 0 0 10px rgba(255, 193, 7, 0.3);
}

.-description {
  color: #a0a0a0;
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  margin-top: 10px;
}

/* Coins Display */
.x-coins-display {
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
}

.-coins-badge {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 25px;
  background: linear-gradient(135deg, rgba(254, 195, 63, 0.2), rgba(254, 138, 2, 0.2));
  border: 1px solid #fec33f;
  border-radius: 50px;
  box-shadow: 0 0 30px rgba(254, 195, 63, 0.3);
  animation: glow-pulse 2s ease-in-out infinite;
}

@keyframes glow-pulse {
  0%, 100% {
    box-shadow: 0 0 20px rgba(254, 195, 63, 0.2);
  }
  50% {
    box-shadow: 0 0 35px rgba(254, 195, 63, 0.5);
  }
}

.-coin-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(180deg, #fec33f, #fe8a02);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.-coin-icon i {
  color: #1b1b41;
  font-size: 18px;
}

.-coin-info {
  display: flex;
  flex-direction: column;
}

.-coin-info .-label {
  font-family: 'Kanit', sans-serif;
  font-size: 11px;
  color: #a0a0a0;
}

.-coin-info .-value {
  font-family: 'Kanit', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #ffc107;
}

/* Rewards Grid */
.x-rewards-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 25px;
}

@media (min-width: 768px) {
  .x-rewards-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 992px) {
  .x-rewards-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.x-reward-card {
  background: rgba(16, 16, 39, 0.95);
  border: 1px solid rgba(254, 195, 63, 0.3);
  border-radius: 20px;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
}

.x-reward-card:hover:not(.-unavailable) {
  transform: translateY(-5px);
  border-color: #fec33f;
  box-shadow: 0 10px 30px rgba(254, 195, 63, 0.2);
}

.x-reward-card.-unavailable {
  cursor: not-allowed;
}

.-image-wrapper {
  position: relative;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.03);
}

.-reward-img {
  width: 100%;
  max-width: 150px;
  height: auto;
  border-radius: 10px;
  transition: transform 0.3s ease;
}

.x-reward-card:hover:not(.-unavailable) .-reward-img {
  transform: scale(1.05);
}

.x-reward-card.-unavailable .-reward-img {
  filter: grayscale(100%);
  opacity: 0.5;
}

.-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.-overlay i {
  font-size: 30px;
  color: #f87171;
}

.-overlay span {
  font-family: 'Kanit', sans-serif;
  font-size: 11px;
  color: #f87171;
}

.-card-content {
  padding: 15px;
  text-align: center;
}

.-reward-name {
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.-price-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  background: rgba(254, 195, 63, 0.15);
  border: 1px solid rgba(254, 195, 63, 0.3);
  border-radius: 20px;
  margin-bottom: 12px;
}

.-price-tag i {
  color: #ffc107;
  font-size: 12px;
}

.-price-tag span {
  font-family: 'Kanit', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #ffc107;
}

.-redeem-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 10px 15px;
  background: linear-gradient(180deg, #4ade80, #22c55e);
  border: none;
  border-radius: 25px;
  color: #fff;
  font-family: 'Kanit', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(34, 197, 94, 0.3);
}

.-redeem-btn:hover:not(:disabled) {
  background: linear-gradient(180deg, #22c55e, #16a34a);
  box-shadow: 0 6px 20px rgba(34, 197, 94, 0.4);
}

.-redeem-btn:disabled {
  background: linear-gradient(180deg, #666, #555);
  cursor: not-allowed;
  box-shadow: none;
}

.-redeem-btn i {
  font-size: 12px;
}

/* Empty State */
.x-empty-state {
  text-align: center;
  padding: 60px 20px;
  background: rgba(16, 16, 39, 0.95);
  border: 1px solid rgba(254, 195, 63, 0.3);
  border-radius: 20px;
  margin-bottom: 25px;
}

.x-empty-state i {
  font-size: 60px;
  color: rgba(254, 195, 63, 0.3);
  margin-bottom: 20px;
}

.x-empty-state p {
  font-family: 'Kanit', sans-serif;
  font-size: 16px;
  color: #a0a0a0;
  margin: 0;
}

/* Info Card */
.x-info-card {
  background: rgba(16, 16, 39, 0.95);
  border: 1px solid rgba(254, 195, 63, 0.3);
  border-radius: 20px;
  overflow: hidden;
}

.-info-header {
  background: linear-gradient(180deg, #7a02fa, #5a01c0);
  padding: 15px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.-info-header i {
  color: #ffc107;
  font-size: 16px;
}

.-info-header span {
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.-info-content {
  padding: 20px;
  text-align: center;
}

.-info-content p {
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  color: #d0d0d0;
  margin: 0 0 10px;
  line-height: 1.6;
}

.-info-content .-sub-text {
  font-size: 12px;
  color: #a0a0a0;
  margin: 0;
}

.-highlight-link {
  color: #ffc107;
  text-decoration: none;
  font-weight: 600;
}

.-highlight-link:hover {
  text-decoration: underline;
}

/* Responsive */
@media (max-width: 576px) {
  .x-rewards-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .x-reward-card {
    border-radius: 15px;
  }

  .-image-wrapper {
    padding: 10px;
  }

  .-reward-img {
    max-width: 100px;
  }

  .-card-content {
    padding: 10px;
  }

  .-reward-name {
    font-size: 12px;
  }

  .-price-tag {
    padding: 4px 10px;
  }

  .-price-tag span {
    font-size: 11px;
  }

  .-redeem-btn {
    padding: 8px 12px;
    font-size: 11px;
  }

  .x-page-title-component .-title {
    font-size: 20px;
  }

  .-coins-badge {
    padding: 10px 20px;
  }

  .-coin-info .-value {
    font-size: 18px;
  }
}
</style>
